import {log} from '@/model/logger';
import naja from 'naja';

export default class ReloadContainer {
    public constructor(element: Element) {
        const url = element.getAttribute('data-reload-url');
        const secondsString = element.getAttribute('data-reload-seconds');

        if (url === null) {
            throw new Error('There is no reload target url specified');
        }

        if (secondsString === null) {
            throw new Error('There is no reload target period specified');
        }

        const seconds = parseInt(secondsString, 10);

        if (isNaN(seconds)) {
            throw new Error(`"${secondsString}" is not valid number of seconds`);
        }

        let interval: number;

        interval = setInterval(
            () => {
                if (! element.isConnected) {
                    clearInterval(interval);
                }
                naja.makeRequest('GET', url).then(() => log('Reload finished', element));
            },
            seconds * 1000,
        );
    }
}
